export const STRIVACITY_CONSENT_LIST_QUERY_KEY = "strivacityConsent";
export const STRIVACITY_ACCESS_TOKEN_QUERY_KEY = "strivacityAccessToken";
export const STRIVACITY_REFRESH_TOKEN_QUERY_KEY = "strivacityRefreshToken";
export const STRIVACITY_USER_DATA_QUERY_KEY = "strivacityUserData";
export const ENGAGE_ACCESS_TOKEN_QUERY_KEY = "engageAccessToken";
export const ENGAGE_USER_INFORMATION_QUERY_KEY = "engageUserInformation";
export const CSRF_TOKEN_QUERY_KEY = "csrfToken";
export const MEMBERSHIP_POINTS_QUERY_KEY = "membershipPoints";
